import { useMutation } from 'react-query';
import { albumEditRequest } from 'src/models/gallery';
import { createAlbum, updateAlbum } from 'src/services/gallery';

export default function useUpdateAlbum(id: number) {
  return useMutation((data: albumEditRequest) => updateAlbum(data, id));
}
